/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --gap: var(--nve-ref-space-xxs);
  --height: var(--nve-ref-size-500);
  --font-size: var(--nve-ref-font-size-50);
  --color: var(--nve-sys-text-muted-color);
  --font-weight: var(--nve-ref-font-weight-medium);
}

[internal-host] {
  --_font-size: var(--font-size);
  --_font-weight: var(--font-weight);
  --_color: var(--color);
  --_height: var(--height);
}

ol,
li {
  list-style-type: none;
  padding: 0;
  display: flex;
  margin: 0;
  min-height: 0;
  align-items: flex-start;
  justify-content: stretch;
  gap: var(--gap);
}

li {
  display: flex;
  align-items: center;
  justify-content: center;
  text-wrap: nowrap;
  height: var(--_height);
}

::slotted(nve-button) {
  --border-radius: calc(var(--nve-ref-border-radius-xs) / 2);
  --font-size: var(--_font-size);
  --color: var(--_color);
  --padding: 0 var(--nve-ref-size-100);
  --height: var(--_height);
  --font-weight: var(--_font-weight);
  --text-decoration: none !important;
  --_border-bottom-offset: -0.5;
  --_border-bottom-width: 85%;
}

::slotted(nve-icon-button) {
  --border-radius: calc(var(--nve-ref-border-radius-xs) / 2);
  --icon-width: var(--nve-ref-size-300);
  --icon-height: var(--nve-ref-size-300);
  --height: var(--_height);
  --width: var(--_height);
  --font-size: var(--_font-size);
  --font-weight: var(--_font-weight);
  --color: var(--_color);
}

nve-icon[separator] {
  --height: var(--nve-ref-size-200);
  --width: var(--nve-ref-size-200);
  --color: var(--_color);
}

::slotted(span) {
  font-size: var(--_font-size);
  color: var(--_color);
  display: block;
}

::slotted(*:last-child) {
  color: var(--nve-sys-text-emphasis-color);
  font-weight: var(--nve-ref-font-weight-semibold);
  --font-weight: var(--nve-ref-font-weight-semibold);
  --color: var(--nve-sys-text-emphasis-color);
}

[hidden-slot] {
  gap: var(--nve-ref-space-sm);
  display: flex;
  align-items: center;
}
